import styled from 'styled-components';

const BtnGroup = styled.div`
  display:flex;
  justify-content: center;
  flex-wrap: wrap;
  >* {
    margin: 0 20px 10px;
  }
`;

export default BtnGroup;